<template>
    <div>
        <div
            class="text-center"
            v-html="this.brandFooter"
            v-if="this.brandFooter"
        />
        <!-- <lonewolf-footer
            v-else-if="isLonewolf"
        /> -->
    </div>
</template>

<script>
import LonewolfFooter from "./Footers/LonewolfFooter/LonewolfFooter";

export default {
    name: "ReferringPlatformFooter",
    components: {
        LonewolfFooter
    },
    props: {
        referringPlatformAppResource: {
            type: Object,
            default: () => ({})
        },
    },
    computed: {
        isLonewolf() {
            return this.referringPlatformAppResource?.slug === 'lonewolf';
        },
        brandFooter() {
            return this.referringPlatformAppResource?.brandFooter;
        },
    },
}
</script>